import React from "react";
import { useI18n } from "@/i18n/I18nContext";

/**
 * BrandSeal — small luxury parchment-seal button anchored bottom-right,
 * sitting ABOVE the Emergent platform badge. Same approximate width and
 * visual footprint as the badge so it reads as part of one intentional
 * corner-stack, not a competing CTA.
 *
 * Visual intent: ivory/parchment fill, fine sepia hairline border, mono
 * label in tobacco brown, restrained gold pip on the left. No glow, no
 * shadow halo, no neon, no bounce. Only opacity transitions on hover.
 *
 * Function: smooth-scroll to the Work With Us / Private Consultation
 * form inside the Archive chapter (`#archive` anchor, then the
 * `archive-cellar-inquiry` block).
 */

export default function BrandSeal() {
  const { lang } = useI18n();

  const handleClick = () => {
    const target =
      document.getElementById("work") ||
      document.getElementById("archive-cellar-inquiry") ||
      document.getElementById("archive");
    target?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const label = lang === "es" ? "Contáctanos" : "Private Consultation";

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="brand-seal"
      aria-label={
        lang === "es"
          ? "Solicitar una consulta privada con la casa Ramírez"
          : "Request a private consultation with the Ramirez house"
      }
      className="brand-seal"
    >
      <span className="brand-seal__pip" aria-hidden="true" />
      <span className="brand-seal__label">{label}</span>
    </button>
  );
}
